import {
  FETCH_TEAM_MEMBERS_SUCCESS,
  FetchTeamMembersSuccessAction,
  SET_CONTRIBUTOR_LIMIT,
  SET_LOADING_TEAMMATES,
  SET_SHOULD_ENFORCE_CONTRIBUTORS,
  SET_TEAM_DETAILS_SUCCESS,
  SetContributorLimitActionAction,
  SetLoadingTeammatesAction,
  SetShouldEnforceContributorsAction,
  SetTeamDetailsSuccessAction
} from '../actions/action-types';
import { TeamDetailsState } from '../configure-store';

const EMPTY_STATE: TeamDetailsState = {};

export const teamDetails = (state = EMPTY_STATE, action: FetchTeamMembersSuccessAction | SetTeamDetailsSuccessAction | SetContributorLimitActionAction | SetShouldEnforceContributorsAction | SetLoadingTeammatesAction): TeamDetailsState => {
  switch (action.type) {
    case FETCH_TEAM_MEMBERS_SUCCESS:
      const { name, image, targetAccountId, userId, permissions, loggedInAccountId, transferOwnershipLink, contributorLimit } = action.roles.accountInfo;
      return { ...state, name, imageUrl: image, targetAccountId, userId, permissions, loggedInAccountId, transferOwnershipLink, contributorLimit };
    case SET_TEAM_DETAILS_SUCCESS:
      return { ...state, ...action.teamDetails };
    case SET_CONTRIBUTOR_LIMIT:
      return { ...state, ...action };
    case SET_SHOULD_ENFORCE_CONTRIBUTORS:
      return { ...state, ...action };
    case SET_LOADING_TEAMMATES:
      return { ...state, ...action };
    default:
      return state;
  }
};
